export default __webpack_public_path__ + "static/media/transparency-step-1.226b0db5.svg";